// Pure overlay-state rules for the channel icon-landing view in ThreadDetailPage.
// Extracted so the mutual-exclusion behavior between Dashboard / Data Sources / Settings
// can be unit tested independently of the component's rendering and API calls.

export interface ChannelLandingFlags {
  isDashboardOpen: boolean;
  isSourcePanelOpen: boolean;
  isSettingsDrawerOpen: boolean;
}

/** True when none of the three panels are open — shows just the icon-only landing view. */
export const isChannelIconLandingOpen = (flags: ChannelLandingFlags): boolean =>
  !flags.isDashboardOpen && !flags.isSourcePanelOpen && !flags.isSettingsDrawerOpen;

/** Opening Dashboard from its icon brings it to front, over Data Sources / Settings. */
export const openDashboardFlags = (flags: ChannelLandingFlags): ChannelLandingFlags => ({
  ...flags,
  isDashboardOpen: true,
  isSourcePanelOpen: false,
  isSettingsDrawerOpen: false,
});

/** Closing Dashboard returns to the icon-only landing view for this channel. */
export const closeDashboardFlags = (flags: ChannelLandingFlags): ChannelLandingFlags => ({
  ...flags,
  isDashboardOpen: false,
});

/**
 * Opening Data Sources shows it at the front (z-index 1350) with the Dashboard kept open
 * in the background (z-index 1300) so the email thread conversation is hidden behind it.
 * Settings is closed because it occupies the same visual layer as the Dashboard and would
 * create a confusing three-panel stack. Both the icon-toggle handler and the ?viewDS=true
 * deep-link handler in ThreadDetailPage route through this function so the two entry points
 * always produce the same flag state.
 */
export const openSourcePanelFlags = (flags: ChannelLandingFlags): ChannelLandingFlags => ({
  ...flags,
  isDashboardOpen: true,
  isSourcePanelOpen: true,
  isSettingsDrawerOpen: false,
});

/** Closing Data Sources returns to the icon-only landing view for this channel. */
export const closeSourcePanelFlags = (flags: ChannelLandingFlags): ChannelLandingFlags => ({
  ...flags,
  isSourcePanelOpen: false,
});
